export default __webpack_public_path__ + "static/media/bo.86a0310e.svg";